

const Config = {
    // analyticsColorsShort: ['#5CFF67', '#DEFF5C', '#FFB85C', '#FF875C', '#FF5C72', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
    // analyticsColorsShort: ['#971D2B', '#E3754F', '#F9E196', '#DDEE97', '#7BBB6D', '#D93B4D', '#E3754F', '#F9E196', '#DDEE97', '#7BBB6D'],
    analyticsColorsShort: ['#D93B4D', '#E3754F', '#F9E196', '#DDEE97', '#7BBB6D', '#D93B4D', '#E3754F', '#F9E196', '#DDEE97', '#7BBB6D'],
    analyticsColorsAll: {
        'col1': ['#7a1db4', '#9a3ee9', '#bb70ff', '#d8a2ee'],
        'col2': ['#4531c3', '#5847eb', '#7a7aff', '#9ea1ff'],
        'col3': ['#0d60cd', '#2c90e8', '#66b8ff', '#94cdff'],
        'col4': ['#039cb3', '#1bc3cf', '#6aebf4', '#99fcff'],
        'col5': ['#00c287', '#2ce8a3', '#5cffc3', '#8fffd4'],
        'col6': ['#1fb601', '#58e82c', '#82ff5c', '#b0ffa1'],
        'col7': ['#b0bd00', '#c8e82c', '#e4ff5c', '#ecff8e'],
        'col8': ['#b37700', '#e89c2c', '#ffbe5c', '#ffd991'],
        'col9': ['#c83403', '#e95a3a', '#ff7a5c', '#ffa676'],
        'col10': ['#b2001e', '#e3214e', '#ff6186', '#ff93a6'],
        'col11': ['#333333', '#999999', '#ffffff', '#616161']
    }
}


export default Config;